<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				template
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_view')}}:
								| {{ $i18n.tc('trainer.trainer_gameFormSetting_' + settings.viewType, 1) }}
						br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_mode')}}:
								| {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.mode) }}
						br
						template(v-if='settings.selectedGroups.length !== 0')
								span
										| {{ groupsString }}:
										| {{ settings.selectedGroups.join('; ') }}
								br
								div(v-for='(group, index) in lettersForGroups', :key='index')
										span
												| {{ group.name }}:
												| {{ group.letters.join('; ') }}
										br
						span
								| {{ $i18n.t('trainer.trainer_gameFormSetting_showTime') }}:
								| {{ settings.showTime }}
								| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
						br
						template(v-if="settings.isSeries && settings.mode === 'interactive'")
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_showInSeries', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.viewType)}) }}:
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
								br
								span
										| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}:
										| {{ settings.seriesAmount }}
								br
						span
								| {{ amountOfItemsString }}:
								| {{ settings.amountOfWords }}
						br
						template(v-if="settings.mode === 'static'")
								span
										| {{ $i18n.t('olympiads.olympiads_olympiadForm_timeForAnswer') }}:
										| {{ settings.timeForAnswer }}
										| {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
								br
						span(v-if='settings.wordsMovement')
								| {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_' + settings.viewType)}) }}:
								| {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
						br
						span
								| {{ invertedString }}:
								span
										| {{ settings.invertedWords ? $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') : $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
						br
						span(v-if="settings.viewType === 'words'")
								| {{ $i18n.t('trainer.trainer_gameFormSetting_accentedWords') }}:
								span
										| {{ settings.accentedWords ? $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') : $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
						br
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";
    import {cloneDeep} from "lodash";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        },
        mounted() {
            if (!this.game.parameters.default['Группа 1 (ма, ро)'] && this.game.parameters.default['группа1МаРо']) {
                this.$set(this.game.parameters.default, 'Группа 1 (ма, ро)', cloneDeep(this.game.parameters.default['группа1МаРо']));
            }
            if (!this.game.parameters.default['Группа 2 (мя, ки)'] && this.game.parameters.default['группа2МяКи']) {
                this.$set(this.game.parameters.default, 'Группа 2 (мя, ки)', cloneDeep(this.game.parameters.default['группа2МяКи']));
            }
            if (!this.game.parameters.default['Группа 3 (ам, ор)'] && this.game.parameters.default['группа3АмОр']) {
                this.$set(this.game.parameters.default, 'Группа 3 (ам, ор)', cloneDeep(this.game.parameters.default['группа3АмОр']));
            }
            if (!this.game.parameters.default['Группа 4 (ям, ер)'] && this.game.parameters.default['группа4ЯмЕр']) {
                this.$set(this.game.parameters.default, 'Группа 4 (ям, ер)', cloneDeep(this.game.parameters.default['группа4ЯмЕр']));
            }
        },
        computed: {
            amountOfItemsString () {
                switch (this.settings.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfWords');
                    case('syllables'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfSyllables');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_amountOfLetters');
                }
            },
            invertedString () {
                switch (this.settings.viewType) {
                    case ('words'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedWords');
                    case('syllables'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedSyllables');
                    case ('letters'):
                        return this.$i18n.t('trainer.trainer_gameFormSetting_invertedLetters');
                }
            },
            groupsString () {
                return this.settings.viewType !== 'letters'
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_groups')
                    : this.$i18n.tc('trainer.trainer_gameFormSetting_letters', 1)
            },
            lettersForGroups() {
                let newArray = [];
                let groupsWithLettersSetting = ['Группа 1 (ма, ро)', 'Группа 2 (мя, ки)', 'Группа 3 (ам, ор)', 'Группа 4 (ям, ер)'];
                groupsWithLettersSetting.forEach(key => {
                    if (this.game.parameters.default[key] && this.game.parameters.default.selectedGroups.find(item => item.includes(key))) {
                        newArray.push({
                            name: key,
                            letters: this.game.parameters.default[key],
                        });
                    }
                });
                this.game.parameters.default.lettersForGroups = newArray;
                return newArray;
            }
        }
    }
</script>
